<template>
    <div class="d-flex align-items-top">
        <span class="material-icons label">{{icon}}</span>
        <span class="ml-2 label text-muted" style="font-weight: 600;">{{label}}</span>
        <span class="ml-2">{{value}}</span>
    </div>
</template>
<script>

export default {
    props :{
        label : {
            type : String,
            default : "",
        },
        value : {
            default : "",
        },
        icon : {
            type : String,
            default : "",
        },
    }
}
</script>
<style scoped>
    span.material-icons.label {
        color: #EEC068;
    }
    .label{
        overflow: inherit;
    }
</style>